import { render } from "./PetList.vue?vue&type=template&id=51d1cccc"
import script from "./PetList.vue?vue&type=script&lang=js"
export * from "./PetList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__